import PropTypes from 'prop-types';
import { ChildrenPropType } from '../../services/proptypes';
import { smoothScroll } from '../../services/scroll';
var propTypes = {
  // id of the component that is going to be scrolled to
  componentId: PropTypes.string.isRequired,
  children: ChildrenPropType
};
export default function PageAnchor(_ref) {
  var componentId = _ref.componentId,
    children = _ref.children;
  var onClick = function onClick(e) {
    e.preventDefault();
    smoothScroll(componentId);
  };
  return children({
    onClick: onClick
  });
}
PageAnchor.propTypes = propTypes;